import React from 'react'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { useTheme } from '@material-ui/core/styles'

import {
    CLASSNAME
} from '../../business-const/Style/Style'

import {
    pesquisaList
} from '../../business-rules/List/ListService'

import {
    reorder,
    move,
    getItemStyle,
    getListStyle,
} from './DragDropTwoListService'



const DragDropTwoList = ( { label1, name1, list1, label2, name2, list2, handleChange } ) => {

    const theme = useTheme()

    const setList1 = ( list ) => {

        handleChange({
            target: {
                name: name1,
                value: list,
            },
        })
    }

    const setList2 = ( list ) => {

        handleChange({
            target: {
                name: name2,
                value: list,
            },
        })
    }

    const getList = (id) => (id === 'droppable' ? list1 : list2)

    const onDragEnd = (result) => {

        const { draggableId, source, destination } = result

        // dropped outside the list
        if (!destination) {
            return
        }

        if (source.droppableId === destination.droppableId) {
            
            const items = reorder(
                getList(source.droppableId),
                source.index,
                destination.index
            )

            if (source.droppableId === 'droppable2') {
                setList2(items)
            } else {
                setList1(items)
            }

        } else {

            if (pesquisaList(list1, draggableId).obrigatorio) {

                return
            }

            const result = move(
                getList(source.droppableId),
                getList(destination.droppableId),
                source,
                destination
            )

            setList1(result.droppable)
            setList2(result.droppable2)
        }
    }

    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <div className="flex justify-around mt-3 mb-3">
                <Droppable droppableId="droppable">
                    {(provided, snapshot) => (
                        <div
                            ref={provided.innerRef}
                            style={getListStyle(snapshot.isDraggingOver)}
                        >
                            <div
                                className={CLASSNAME().dragDropTwoListTitle}
                            >
                                {label1 + ': ' + list1.length}
                            </div>
                            <br/>
                            <br/>
                            {list1?.map((item, index) => (
                                <Draggable
                                    key={item.id}
                                    draggableId={item.id}
                                    index={index}
                                >
                                    {(provided, snapshot) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            style={getItemStyle(
                                                snapshot.isDragging,
                                                provided.draggableProps.style,
                                                theme,
                                                item.obrigatorio,
                                                item.especial,
                                            )}
                                            dangerouslySetInnerHTML={{ __html: item.content}}
                                        />
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
                <Droppable droppableId="droppable2">
                    {(provided, snapshot) => (
                        <div
                            ref={provided.innerRef}
                            style={getListStyle(snapshot.isDraggingOver)}
                        >
                            <div
                                className={CLASSNAME().dragDropTwoListTitle}
                            >
                                {label2 + ': ' + list2.length}
                            </div>
                            <br/>
                            <br/>
                            {list2?.map((item, index) => (
                                <Draggable
                                    key={item.id}
                                    draggableId={item.id}
                                    index={index}
                                >
                                    {(provided, snapshot) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            style={getItemStyle(
                                                snapshot.isDragging,
                                                provided.draggableProps.style,
                                                theme,
                                                item.obrigatorio,
                                                item.especial,
                                            )}
                                            dangerouslySetInnerHTML={{ __html: item.content}}
                                        />
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </div>
        </DragDropContext>
    )
}

export default DragDropTwoList